import React, { Fragment } from "react";
import "@redq/reuse-modal/es/index.css";
import "../customElements/css/home.css";
import "../customElements/css/dyesSubPages.css";
import CustomSection from "../customElements/components/section";
import styled from "styled-components";
import DetailsCard from "../customElements/components/detailsCard";
import Contactdetails from "../customElements/components/contactdetailscard";
import { Container } from "../customElements/components/yuvaContainer";
import Layout from "../customElements/components/layout.js";
import BannerSections from "../customElements/components/bannerSection";
import BannerImg from "../images/dyes/dyes_cash_reward_banner_img.png";

class CashAward extends React.Component {
  constructor() {
    super();

    this.state = {
      isKannada: true
    };
    this.toggleLang = this.toggleLang.bind(this);
  }

  toggleLang() {
    this.setState({ isKannada: !this.state.isKannada });
  }
  render() {
    return (
      <Layout
        title="Yuva | ನಗದು ಪುರಸ್ಕಾರ | CASH AWARD "
        isKannada={this.state.isKannada}
        toggleLang={this.toggleLang}
      >
        <BannerSections
          bgImg={BannerImg}
          title={this.state.isKannada ? "ನಗದು ಪುರಸ್ಕಾರ" : "Cash Award"}
        ></BannerSections>
        <div className="section">
          <Container>
            <div className="AboutUsDiscText1">
              {this.state.isKannada
                ? "ಒಂದೇ ಸೂರಿನಡಿ ಯುವಕರಿಗೆ ಮಾಹಿತಿ, ಸ್ಫೂರ್ತಿ ಮತ್ತು ತರಬೇತಿಯನ್ನು ನೀಡಲು ಕರ್ನಾಟಕ ಸರ್ಕಾರವು ಮಾಡಿದ ಪ್ರಯತ್ನಗಳನ್ನು ಯುವ ಸಬಲಿಕರಣ ಕೇಂದ್ರಗಳ ರೂಪದಲ್ಲಿ ಸಾಕಾರಗೊಳಿಸಲಾಗಿದೆ. ಈ ಕೇಂದ್ರಗಳನ್ನು ಪ್ರತಿ ಜಿಲ್ಲೆಗೆ, ಎಲ್ಲಾ ಜಿಲ್ಲೆಗಳಲ್ಲಿ, ಆಯಾ ಲೀಡ್ ಸರ್ಕಾರಿ ಪ್ರಥಮ ದರ್ಜೆ ಕಾಲೇಜುಗಳಲ್ಲಿ ಸ್ಥಾಪಿಸಲಾಗಿದೆ. ಈ ಕೇಂದ್ರಗಳು ಉನ್ನತ ಶಿಕ್ಷಣದಲ್ಲಿ ವೃತ್ತಿ ಆಯ್ಕೆಗಳು ಮತ್ತು ಅವಕಾಶಗಳ ಬಗ್ಗೆ ಜಾಗೃತಿ ಮೂಡಿಸುವ ಗುರಿಯನ್ನು ಹೊಂದಿವೆ."
                : "The efforts of the Karnataka Government to provide information, inspiration and training to youth under a single roof is actualized in the form of Yuva Sabalikarana Kendras. These Kendras are established one per district, in all districts, at the respective Lead Government First Grade Colleges. These Kendras aim at creating awareness about career choices and Opportunities in Higher Education, in fields opted."}
            </div>
          </Container>

          <CustomSection
            secTitle={this.state.isKannada ? "ಅರ್ಹತೆ" : "Eligibility"}
            secHeading={
              this.state.isKannada ? "ಅರ್ಹತಾ ಮಾನದಂಡ" : "Eligibility Critirea"
            }
            dim={false}
          >
            <Container>
              <table class="table" style={{ fontFamily: "Lato" }}>
                <thead class="thead-light">
                  {this.state.isKannada ? (
                    <tr>
                      <th scope="col" className="TableHeaderStyling">
                        ಕ್ರ.ಸಂ.
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        ವಿವರ
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        ಚಿನ್ನ (&#8377;)
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        ಬೆಳ್ಳಿ (&#8377;)
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        ಕಂಚು (&#8377;)
                      </th>
                    </tr>
                  ) : (
                    <tr>
                      <th scope="col" className="TableHeaderStyling">
                        SL NO
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        DETAILS
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        GOLD (&#8377;)
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        SILVER (&#8377;)
                      </th>
                      <th scope="col" className="TableHeaderStyling">
                        BROZE (&#8377;)
                      </th>
                    </tr>
                  )}
                </thead>
                <tbody>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      1
                    </th>
                    {this.state.isKannada ? (
                      <td>ಒಲಿಂಪಿಕ್ ಕ್ರೀಡೆಗಳು</td>
                    ) : (
                      <td>Olympic Games</td>
                    )}
                    <td>500.00</td>
                    <td>300.00</td>
                    <td>200.00</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      2
                    </th>
                    {this.state.isKannada ? (
                      <td>ಏಷಿಯನ್ ಕ್ರೀಡೆಗಳು</td>
                    ) : (
                      <td>Asian Games</td>
                    )}
                    <td>25.00</td>
                    <td>15.00</td>
                    <td>8.00</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      3
                    </th>
                    {this.state.isKannada ? (
                      <td>ಕಾಮನ್‍ವೆಲ್ತ್ ಕ್ರೀಡೆಗಳು</td>
                    ) : (
                      <td>Commonwealth Games</td>
                    )}
                    <td>25.00</td>
                    <td>15.00</td>
                    <td>8.00</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      4
                    </th>
                    {this.state.isKannada ? (
                      <td>
                        ವಿಶ್ವಕಪ್/ ಚಾಂಪಿಯನ್‍ಶಿಪ್ (ಭಾರತದ ತಂಡದಲ್ಲಿ ಭಾರತ ಸರ್ಕಾರದಿಂದ
                        ಪ್ರತಿನಿಧಿಸಿರತಕ್ಕದ್ದು)
                      </td>
                    ) : (
                      <td>World cup / Championship (Government only)</td>
                    )}
                    <td>5.00</td>
                    <td>3.00</td>
                    <td>2.00</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      5
                    </th>
                    {this.state.isKannada ? (
                      <td>ರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡೆ (ಪ್ರತೀ 4 ವರ್ಷಗಳಲ್ಲಿ)</td>
                    ) : (
                      <td>National Games (sports every four years)</td>
                    )}
                    <td>5.00</td>
                    <td>3.00</td>
                    <td>2.00</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      6
                    </th>
                    {this.state.isKannada ? (
                      <td>ರಾಷ್ಟ್ರೀಯ ಚಾಂಪಿಯನ್‍ಶಿಪ್ (ಒಲಿಂಪಿಕ್ ಕ್ರೀಡೆಗೆ ಮಾತ್ರ)</td>
                    ) : (
                      <td>National Championship (for Olympic Games only)</td>
                    )}
                    <td>2.00</td>
                    <td>1.00</td>
                    <td>0.50</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      7
                    </th>
                    {this.state.isKannada ? (
                      <td>
                        ಕಿರಿಯರ ವಿಭಾಗದ ರಾಷ್ತ್ರೀಯ ಕ್ರೀಡಾಪಟು (ಒಲಿಂಪಿಕ್ ಕ್ರೀಡೆಗಳಿಗೆ
                        ಮಾತ್ರ)
                      </td>
                    ) : (
                      <td>Junior National (for Olympic Games only)</td>
                    )}
                    <td>0.50</td>
                    <td>0.25</td>
                    <td>0.15</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      8
                    </th>
                    {this.state.isKannada ? (
                      <td>
                        ರಾಷ್ಟ್ರೀಯ ಕಿರಿಯರ ಉಪ ವಿಭಾಗ (ಒಲಿಂಪಿಕ್ ಕ್ರೀಡೆಗಳಿಗೆ ಮಾತ್ರ)
                      </td>
                    ) : (
                      <td>Sub junior national (only for Olympic Games)</td>
                    )}
                    <td>0.25</td>
                    <td>0.15</td>
                    <td>0.10</td>
                  </tr>
                  <tr>
                    <th scope="row" className="TableSerialNumber">
                      9
                    </th>
                    {this.state.isKannada ? (
                      <td>ಚೆಸ್ ಗ್ರ್ಯಾಂಡ್ ಮಾಸ್ಟರ್</td>
                    ) : (
                      <td>Chess Grandmaster</td>
                    )}
                    <td>10.00</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </Container>
          </CustomSection>
          {/* <CustomSection>> */}
          <Container>
            <div className="w-100 m-auto">
              <DetailsCard
                detailtitle={
                  this.state.isKannada
                    ? "ಬೇಕಾದ ಪೂರಕ ದಾಖಲೆಗಳು"
                    : "Documents required"
                }
              >
                {this.state.isKannada ? (
                  <ul>
                    <li>
                      ಅರ್ಹತಾ ಮಾನದಂಡದಲ್ಲಿ ಸಂಘಟಕರು ನೀಡಿರುವ ಪದಕ ಪ್ರಮಾಣಪತ್ರ /
                      ಭಾಗವಹಿಸಿರುವ ಪ್ರಮಾಣ ಪತ್ರ.
                    </li>
                    <li>
                      ಅರ್ಹತಾ ಮಾನದಂಡದಲ್ಲಿ ಸಂಘಟಕರು ನೀಡಿರುವ ಪದಕ ಪ್ರಮಾಣಪತ್ರ /
                      ಭಾಗವಹಿಸಿರುವ ಪ್ರಮಾಣ ಪತ್ರ. ರಾಷ್ಟ್ರಿಯ ಮಟ್ಟದ ಸ್ಪರ್ಧೆಗೆ
                      ಆ0iÉ್ಕುಯಾಗಿರುವ ಬಗ್ಗೆ ರಾಜ್ಯ ಕ್ರೀಡ ಒಕ್ಕೂಟ ಮತ್ತು ಅಂತರಾಷ್ಟ್ರೀಯ
                      ಸ್ಪರ್ಧೆಗಳಿಗೆ{" "}
                    </li>
                  </ul>
                ) : (
                  <ul>
                    <li>
                      Medal Certificate/ Participation Certificate issued by the
                      organisers as per the eligibility criteria.
                    </li>
                    <li>
                      Selection letter of state sports association for National
                      level competition and letter of National Sports Federation
                      for International competitions.
                    </li>
                  </ul>
                )}
              </DetailsCard>
            </div>
          </Container>
          {/* </CustomSection> */}
          <div className="pt-5" />
          <Container>
            <div className="w-100 m-auto">
              <DetailsCard detailtitle="contact details">
                <ul className="envolopIcon">
                  <li>dyesjdys@gmail.com</li>
                  <li>ddpykka@gmail.com</li>
                </ul>
              </DetailsCard>
            </div>
          </Container>

          <div className="text-center mt-3 ">
            <a href="https://karepass.cgg.gov.in/#!" target="newtab">
              <button className="infoCtaRedbutton m-auto ">
                <span>
                  {/* {this.state.isKannada ? "" : "Register now"}  */}
                  For more details visit : www.karepass.cgg.gov.in
                </span>
              </button>
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

export default CashAward;
